import { DraftStatus } from '~/types'

export const activeApplicationTab = 'Drafts'
export const inactiveApplicationTab = 'Discontinued'
export const allApplicationTabs = [activeApplicationTab, inactiveApplicationTab]

export const bgAndSuretyDocumentsTabs = ['Established', 'Projected', 'Closed', 'Awaiting Return']
export const allTabs = [activeApplicationTab, ...bgAndSuretyDocumentsTabs, inactiveApplicationTab] as const

export type ApplicationTab = (typeof allTabs)[number]

export const filterApplicationsByStatus = (activeTab: ApplicationTab) => {
  if (activeTab === 'Discontinued') {
    return [DraftStatus.CANCELLED, DraftStatus.REJECTED]
  } else if (activeTab === 'Drafts') {
    return [
      DraftStatus.DRAFT,
      DraftStatus.SUBMISSION_STARTED,
      DraftStatus.IDENTIFYING,
      DraftStatus.CHANGES_REQUESTED,
      DraftStatus.PENDING_PAYMENT,
      DraftStatus.PROCESSING,
      DraftStatus.SUBMITTED
    ]
  }
}
/*
DraftStatus.ESTABLISHED,
DraftStatus.RETURNED,
DraftStatus.AWAITING_RETURN
BE logic, client cannot see applications in these states
*/
